<template>
	<div class="homePage-footer">
		<div class="footer-content">
			<el-row>
				<el-col class="youqinglianjie">
					<img src="/img/友情链接.png" draggable="false" /> <span>友情链接</span>
				</el-col>
				<el-col>
					<img src="/img/you_line.png" draggable="false" />
				</el-col>
				<el-col>
					<!-- <div class="logoList">
						<div v-for="item in newline" class="logoItem">
							<a :href="item.href" target="_blank"><img :src="item.logo" draggable="false" /></a>
						</div>
					</div> -->
					<el-row :gutter="20" class="logoList">
						<el-col :span='6' v-for="item in newline" class="logoItem">
							<a :href="item.href" target="_blank"><img :src="item.logo" draggable="false" /></a>
						</el-col>
					</el-row>
				</el-col>
				<el-col>
					<el-divider></el-divider>
				</el-col>
				<el-col class="bottom-text">
					@ 2023 四川城市职业学院虚拟仿真实训基地网站
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import youqinglinajie from '@/assets/youqinglinajie.js'
	export default {
		data() {
			return {
				newline: []
			}
		},
		created() {
			this.newline = youqinglinajie
		}
	}
</script>

<style lang="scss">
	.homePage-footer {
		height: 370px;
		background-color: #7D3811;
		color: #fff;

		.footer-content {
			width: 1440px;
			margin: 0 auto;

			.youqinglianjie {
				margin-top: 20px;
				font-size: 20px;

				img {
					vertical-align: bottom;
				}

				span {
					margin-left: 10px;
					font-weight: 600;
				}
			}

			.bottom-text {
				height: 40px;
				line-height: 40px;
				text-align: center;
				font-size: 14px;
			}

			.el-divider {
				margin: 10px 0 !important;
			}

			.logoList {
				margin-top: 20px;

				.logoItem {
					padding: 20px;
					
					img {
						height: 60px;
						max-width: 100%;
					}
				}
			}
		}
	}
</style>